import { render, staticRenderFns } from "./CustomOptionsManagerV2.vue?vue&type=template&id=4b940d1d&scoped=true&"
import script from "./CustomOptionsManagerV2.vue?vue&type=script&lang=js&"
export * from "./CustomOptionsManagerV2.vue?vue&type=script&lang=js&"
import style0 from "./CustomOptionsManagerV2.vue?vue&type=style&index=0&id=4b940d1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b940d1d",
  null
  
)

export default component.exports